import { ReactComponent as GenericCardIconSVG } from '@/assets/icons/GenericCardIcon.svg';
import { SVGProps } from 'react';

const GenericCardIcon = (props: SVGProps<SVGSVGElement>) => <GenericCardIconSVG {...props} />;

export default GenericCardIcon;
